import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z","key":"svg-0"}]]

/**
 * IconPointFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItcG9pbnQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDdhNSA1IDAgMSAxIC00Ljk5NSA1LjIxN2wtLjAwNSAtLjIxN2wuMDA1IC0uMjE3YTUgNSAwIDAgMSA0Ljk5NSAtNC43ODN6IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/point-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPointFilled = createReactComponent('filled', 'point-filled', 'PointFilled', __iconNode);

export default IconPointFilled;